import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { SHOW_IDLE_MODE, HIDE_IDLE_MODE } from 'actions/idleMode';
import { IdleMode } from 'store-types';

const INITIAL_STATE = Immutable({
  showOverlay: false,
});

export default (state: Immutable.ImmutableObject<IdleMode> = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SHOW_IDLE_MODE:
      return state.merge({ showOverlay: true });
    case HIDE_IDLE_MODE:
      return state.merge({ showOverlay: false });
    default:
      return state;
  }
};
